import styles from './PageWrapper.module.scss'
import { useSelector } from 'react-redux'

export function PageWrapper({ children }) {
	const shouldHide = useSelector((state) => state.menu?.hidden)
	return <div className={`${styles['page-wrapper']} ${shouldHide ? styles.hidden : ''}`}>{children}</div>
}
export default PageWrapper
